/**
 * @deprecated These format will be removed in favor of using the localization utilities from @wilson/localization
 * Please use the localization utilities instead.
 *
 * @example
 * ```typescript
 * import { toLocalizedDateTimeFormatSignal } from '@wilson/localization';
 *
 * const date = new Date();
 * const dateTimeFormat = toLocalizedDateTimeFormatSignal(date, localizationSetting);
 * ```
 */
export enum DateTimeFormat {
  DatabaseDateFormat = 'yyyy-MM-dd',
  TimeFormat = 'HH:mm',
  GermanDateFormat = 'dd.MM.yyyy',
  GermanDateFormatSort = 'dd.MM.yy',
  GermanDateTimeFormat = 'dd.MM.yyyy - HH:mm',
  DatabaseDateTimeFormat = 'yyyy-MM-dd HH:mm',
  LocalTimeFormat = 'yyyy-MM-ddTHH:mm',
  DayAndMonth = 'dd.MM',
  DayAndMonthSingle = 'd.M',
  GermanDateFormatWithDay = 'EEEE dd.MM.yyyy',
  MonthFormat = 'yyyy-MM',
  TimeDayAndMonth = 'HH:mm, dd.MM',
  GermanDateTimeHourFormat = 'dd.MM.yy, HH:mm',
  GermanDateTimeHourFormatWithSeconds = 'dd.MM.yyyy - HH:mm:ss',
  MonthAndYear = 'MMMM-yyyy',
}
